import * as React from 'react';
import cn from 'classnames';

import StubComponent from 'shared/components/StubComponent';
import LoaderSpinner, {
  LoadingSpinnerSize
} from 'shared/components/animations/LoaderSpinner';
import { BaseListProps } from 'shared/entities/components/list';

import './BaseList.modules.scss';

const BaseList = React.forwardRef(
  (
    {
      children,
      loading,
      listLength,
      loaderSize = LoadingSpinnerSize.s,
      className,
      stub
    }: BaseListProps,
    ref: React.MutableRefObject<HTMLDivElement>
  ) => {
    return (
      <div
        styleName={cn('list', !listLength && 'list_empty')}
        className={className}
        ref={ref}
      >
        {!loading && !!listLength && children}
        {loading && <LoaderSpinner centered size={loaderSize} />}
        {!loading && !listLength && <StubComponent {...stub} />}
      </div>
    );
  }
);

export default BaseList;
